<template>
  <div>
    <button @click="readCurrencyValue()" class="btn btn-more-radius btn-outline-primary">
      Dolar Kuru : {{parityValue}}
    </button>
    <small class="form-text text-center">{{parityDate}}</small>
  </div>
</template>

<script>
/* eslint-disable */

import axios from 'axios'

export default {
  name: 'CurrencyParity',
  computed : {
  },
  data () {
    return {
      parityValue: 0,
      parityDate: "",
    }
  },
  props: {
    currency : String,
    date : String,
  },
  computed: {
  },
  methods: {
    async readCurrencyValue() {
      let xmlResult;
      await axios.post('/api/useful/currency')
      .then(resp => {
        xmlResult = resp.data
        this.parityValue = xmlResult.Tarih_Date.Currency[0].ForexSelling
        this.parityDate = xmlResult.Tarih_Date.Tarih;
      });
    },
    async parseXmlObject() {
    }
  },
  created() { },
  mounted() {
    this.readCurrencyValue();
  },
  destroy() {

  },
}
</script>

<style scoped>
  small {
    margin-top: 0px;
    color: #999 !important;
  }
</style>


// WEBPACK FOOTER //
// src/tool/CurrencyParity.vue